import React from "react";
import { extractDate } from "../../../Components/Functions/date.fun";
const ServiceOrderVendorDetails = ({ data }) => {
  return (
    <div>
      <h3 style={{ textAlign: "center" }}>SERVICE ORDER</h3>
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div>
          <p>
            <span>
              Vendor Service Order Number:{" "}
              <b>{data?.serviceOrderNumber || "N/A"}</b>{" "}
            </span>
            <br />
            {data?.createdAt && (
              <>
                {" "}
                Date:{" "}
                <b>
                  {data?.vendorServiceOrderDate || extractDate(data?.createdAt)}
                </b>
              </>
            )}
            <br />
            Business / Person Name:{" "}
            <b>{data?.businessName || data?.contactPersonName || "N/A"}</b>{" "}
            <br />
            Address: {data?.address || "N/A"} GSTIN:{" "}
            <b>{data?.gstNumber || "N/A"}</b>
          </p>
        </div>
        <div>
          <p>
            Contact Person: <b>{data?.contactPersonName || "N/A"}</b> <br />
            Phone: <b>{data?.phoneNumber || "N/A"}</b> <br />
            Country of Supply: <b>{data?.countryOfSupply || "N/A"}</b> <br />
            Service For: <b>{data?.vendorServiceFor || "N/A"}</b> <br />
          </p>
        </div>
      </div>
    </div>
  );
};

export default ServiceOrderVendorDetails;
